module.exports = __webpack_public_path__ + "img/award-banner.0487632f.jpg";